module.exports = __webpack_public_path__ + "img/1F1F8-1F1FF.6f3f2f65.svg";